import { FormBase } from "core/components";

export default class DressingBoxForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: "frequencyOfCareId",
                    label: "Frequency Of Care",
                    placeholder: "Select a frequency of care",
                    rules: "required",
                },
                {
                    name: "selectedProductId",
                    label: "Selected Product",
                    placeholder: "Select a product",
                    rules: "required",
                },
                {
                    name: "treatmentDurationCategory",
                    label: "Treatement Category",
                    placeholder: "Treatment Category",
                    rules: "required",
                },
                {
                    name: "treatmentDuration",
                    label: "Treatement Duration",
                    placeholder: "Treatement Duration",
                    type: "number",
                    rules: "required",
                },
                {
                    name: "woundId",
                    label: "Wound",
                },
                {
                    name: "applicationTypeAbrv",
                    label: "Application Type Abbreviation",
                },
                {
                    name: "applicationTypeId",
                    label: "Application Type",
                },
            ],
        };
    }
}
